import React from 'react';
import { Handle, Position } from '@xyflow/react';

function VNetNode({ data, selected }) {
  return (
    <div
      className={`relative rounded-md border-2 p-3 transition-colors ${
        selected ? 'border-blue-500 bg-blue-50/70 dark:bg-blue-900/30' : 'border-blue-300 bg-blue-50/40 dark:bg-blue-900/20'
      }`}
      style={{ width: 220, height: 120 }}
    >
      <Handle type="target" position={Position.Top} className="!bg-blue-500" />
      <div className="mb-1 flex items-center gap-2">
        <svg
          className="h-4 w-4 text-blue-600 dark:text-blue-400"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="9" />
          <path d="M3 12h18M12 3a9 9 0 010 18M12 3a9 9 0 000 18" />
        </svg>
        <span className="text-sm font-semibold text-blue-900 dark:text-blue-100">{data.name}</span>
      </div>
      {data.cidr && (
        <span className="inline-block bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200 text-xs font-mono px-2 py-0.5 rounded">
          {data.cidr}
        </span>
      )}
      <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">Virtual Network</div>
      <Handle type="source" position={Position.Bottom} className="!bg-blue-500" />
    </div>
  );
}

export default VNetNode;
